import { z } from "zod";
import { type CustomQuestionsV2, type TypeExtract } from "./config/types";
import { type Ticket } from "./ticket";

export const CustomQuestionSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.enum(["short_answer", "star_rating"]),
    answer: z.string(),
    question: z.string(),
    external_id: z.string(),
    internal_id: z.string(),
  }),
  z.object({
    type: z.literal("date_input"),
    answer: z.string(),
    question: z.string(),
    external_id: z.string(),
    internal_id: z.string(),
    question_qualified: z.boolean().optional(),
  }),
  z.object({
    type: z.literal("multiple_choice"),
    answer: z
      .array(
        z.object({
          answer: z.string(),
          external_id: z.string(),
          internal_id: z.string(),
          qualified: z.boolean().optional(),
        }),
      )
      .or(
        z.object({
          answer: z.string(),
          external_id: z.string(),
          internal_id: z.string(),
          qualified: z.boolean().optional(),
        }),
      ),
    question: z.string(),
    external_id: z.string(),
    internal_id: z.string(),
    question_qualified: z.boolean().optional(),
  }),
  z.object({
    type: z.literal("image_upload"),
    question: z.literal("ugc"),
    external_id: z.string(),
    internal_id: z.string(),
    answer: z.array(z.object({ id: z.string() })),
  }),
]);

export type CustomQuestion = z.infer<typeof CustomQuestionSchema>;

export function filterAlreadyAnsweredQuestions(
  questions: TypeExtract<
    CustomQuestionsV2["custom_questions"]["questions"][number]
  >[],
  ticketQuestions: Ticket["custom_questions"],
) {
  if (!ticketQuestions || ticketQuestions.length === 0) return questions;
  return questions.filter((q) => {
    return !ticketQuestions.some((tq) => {
      const id =
        q.type === "multiple_choice"
          ? q.values.question.internal_id
          : q.values.internal_id;
      return tq.internal_id === id;
    });
  });
}
